﻿import React, { useState, useEffect } from 'react';
import { ItemBasicInformation } from '../models/item-basic-information';
import { NmrSolvent } from '../models/nmr-solvent';
import { BatchStandard } from '../models/batch-standard';
import NmrSolvents from './NmrSolvents';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Selection,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton
}
    from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export interface Props {
    benchSheetId?: string;
    isReadOnly: boolean;
}

export default function NmrSolventsData(props: Props) {
    const [samples, setSamples] =
        useState<NmrSolvent[]>();

    const [selectedStandard, setSelectedStandard] =
        useState<BatchStandard>();

    const [nmrSolventsEditorVisible, setNmrSolventsEditorVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>(false);

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>(false);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    key++;

    return (
        <div>
            <DataGrid width="100%"
                height="21rem"
                keyExpr="solventId"
                dataSource={samples ? samples : []}
                showBorders={true}
                rowAlternationEnabled={true}
                showRowLines={true}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode="nextColumn" >

                <Selection mode={'single'} />

                <Column type="buttons" width='5rem' >
                    <ColumnButton hint="audit information" icon="clock"
                        onClick={onSolventsAuditButtonClicked} />
                    <ColumnButton hint="information" icon="info"
                        onClick={onSolventsInformationButtonClicked} />
                </Column>

                <Column caption="Internal Standards" alignment="center">
                    <Column dataField='internalStandardName' width='5rem' caption="ID" dataType="string"
                        cellRender={renderSampleCell} alignment="center" />
                    <Column dataField='refWeight' width='8rem' caption="Weight" dataType="number" />
                </Column>

                <Column caption="Samples" alignment="center">
                    <Column dataField='sampleName' width='5rem' dataType="string"
                        caption="Sample" cellRender={renderSampleCell} alignment="center" />
                    <Column dataField='sampleWeight' width='8rem' caption="Weight" dataType="number" />

                </Column>

                <Column />

                <Toolbar>
                    <ToolbarItem location="after">
                        <Button hint="Edit" icon="inserttable"
                            disabled={props.isReadOnly}
                            width="1.8rem" onClick={showNmrSolventsEditor} />
                    </ToolbarItem>

                    <ToolbarItem location='after'>
                        <Button type='success' width={'1.8rem'} icon='clock'
                            text='' disabled={true}
                            hint='Solvents Audit Information' />
                    </ToolbarItem>
                </Toolbar>

            </DataGrid>

            {nmrSolventsEditorVisible &&
                <DialogPopup
                    visible={nmrSolventsEditorVisible}
                    onHiding={hideNmrSolventsEditor}
                    dragEnabled={false}
                    fullScreen={true}
                    hideOnOutsideClick={false}
                    title="QNMR Solvents">

                    <NmrSolvents key={`nmrs${key}`}
                        benchSheetId={props.benchSheetId}
                        onClose={onHideNmrSolventsEditor} />

                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function onHideNmrSolventsEditor() {
        hideNmrSolventsEditor();
        getNmrSolvents();
    }

    function onSolventsAuditButtonClicked(e: any) {

    }

    function onSolventsInformationButtonClicked(e: any) {

    }

    async function getNmrSolvents() {
        await CrudFunctions.getData(`benchsheets/nmrsolventsbybenchsheetid/${props.benchSheetId}`)
            .then((data) => {
                setSamples(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving NMR Solvents");
            });
    }

    function getAllData() {
        getNmrSolvents();
    }

    function showNmrSolventsEditor() {
        setNmrSolventsEditorVisible(true);
    }

    function hideNmrSolventsEditor() {
        setNmrSolventsEditorVisible(false);
    }

    //render

    function renderSampleCell(e: any) {
        return <div className="pw-bold">{e.text}</div>;
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}